import React from 'react';
import Widget from './Widget';
import Heatmap from './d3/Heatmap';
import HeatmapChart from './d3/HeatmapChart';

const HeatmapWrapper = ({ data, columns }) => (
    <Widget title="Heatmap" className="heatmap-widget">
        {/* <Heatmap data={data} columns={columns}  /> */}
        <HeatmapChart data={data} columns={columns} />
    </Widget>
);

export default HeatmapWrapper;
